<template>
  <div data-testid="emd-panel-section" class="emd-panel__section">
    <div class="emd-panel__block">
        <div v-if="title" class="el-chunk">
          <p class="emd-text _type_caption">{{title}}</p>
        </div>
        <div class="el-chunk">
          <p class="emd-text _color_nonessential _size_small">
            {{description}}
          </p>
        </div>
    </div>

    <div class="emd-panel__block">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmdPanelSection',
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    description: {
      type: String,
      default: '',
      required: false
    }
  }
}
</script>
